import { useQuery } from "@tanstack/react-query";

import { listingsApi, type MyListingsFilters } from "@/features/listings/services/listings.api";

export function useMyListings(filters: MyListingsFilters = {}) {
  return useQuery({
    queryKey: ["listings", "mine", filters],
    queryFn: () => listingsApi.getMyListings(filters),
  });
}
